export default function registerTab($, apower) {
  //tab panel, controled by data-tab="target tab element class name"
  //will not trigger tabactive when initializing, if tab already has a active class
  $.registerDir("tab", {
    selector: "[data-tab]",

    props: ["tab"],

    tab: "",

    tabEl: null,

    init: function () {
      if (this.tab) {
        var tabEl = $("." + this.tab);
        if (!tabEl.length) {
          tabEl = $("#" + this.tab);
        }

        if (tabEl) {
          this.tabEl = tabEl;
          this.el.$on("click", this.onClick, this);
        }

        if (this.el.is(".active") && !tabEl.is(".active")) {
          $.defer(function () {
            this.el.click();
          }, this);
        }
      }
    },

    onClick: function () {
      var el = this.el;
      var tabEl = this.tabEl;
      var lastTabEl = tabEl.siblings(".active");

      if (tabEl[0] === lastTabEl[0]) {
        return;
      }

      el.siblings().removeClass("active");
      el.addClass("active");

      lastTabEl.removeClass("active");
      tabEl.addClass("active");

      if (lastTabEl.length > 0 && this.hasTransition === undefined) {
        this.hasTransition =
          Number(String(lastTabEl.css("transition-duration")).slice(0, -1)) > 0;
      }

      if (this.hasTransition) {
        tabEl.show();
        lastTabEl.$once("transitionend", this.hideLastTab, this);
        this.lastTabEl = lastTabEl;
      }

      lastTabEl.$trigger("tabinactive", lastTabEl);
      tabEl.$trigger("tabactive", tabEl);
    },

    hideLastTab: function () {
      if (this.lastTabEl && !this.lastTabEl.is(".active")) {
        this.lastTabEl.hide();
        this.lastTabEl = null;
      }
    },
  });
}
